import React from "react";

import classNames from "classnames";

import styles from '../contentcards.module.scss';

export function ContentCardCaptionedImage({ data, onClick }) {

    return (
        <>
            <div className= { classNames(styles.captionedCard) } onClick={onClick}>
                <div className= { classNames(styles.captionedCardImage) }>
                    {data.imageUrl && !data.url && (<img	src={`${data.imageUrl}`} alt={data.title} />)}
                    {data.imageUrl && data.url && (<a target="_blank" href={data.url}><img	src={`${data.imageUrl}`} alt={data.title} /></a>)}
                </div>
                <div className= { classNames(styles.captionedCardContent) }>
                    {data.title && (<h2 className={ classNames(styles.cardHeaderCaptioned) }>{data.title}</h2>)}
                    {data.description && (<p className={ classNames(styles.cardDescription) }>{data.description}</p>)}
                    {data.url && data.linkText && (<div className={ classNames(styles.cardLink) }><a target="_blank" href={data.url}>{data.linkText}</a></div>)}
                </div>
            </div>
        </>
    );
}